import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const PatientFlowChart = ({ data }) => {
  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl md:text-2xl font-semibold text-foreground">Patient Flow Analytics</h2>
          <p className="text-sm text-muted-foreground mt-1">Daily patient volume by service line</p>
        </div>
      </div>
      
      <div className="w-full h-64 md:h-80 lg:h-96" aria-label="Patient Flow Bar Chart">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="time" 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
            />
            <YAxis 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
            />
            <Tooltip 
              contentStyle={{ 
                backgroundColor: 'var(--color-card)',
                border: '1px solid var(--color-border)',
                borderRadius: '8px'
              }}
            />
            <Legend 
              wrapperStyle={{ fontSize: '12px' }}
            />
            <Bar dataKey="outpatient" fill="var(--color-primary)" name="Outpatient" radius={[4, 4, 0, 0]} />
            <Bar dataKey="emergency" fill="var(--color-error)" name="Emergency" radius={[4, 4, 0, 0]} />
            <Bar dataKey="inpatient" fill="var(--color-secondary)" name="Inpatient" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default PatientFlowChart;